const legacyPermissions = (action, permissions, institutionId, year, sdgId) => {
  if (
    action === 'legacy:viewProduct' &&
    permissions[institutionId].some((item) =>
      [
        `IMPACT_EMBARGO_${year}`,
        `SDG_IMPACT_RELEASE_${year}_${sdgId}`,
        `SDG_IMPACT_SUBSCRIPTION_${year}_${sdgId}`,
        `REPUTATION_${year}`,
        `REPUTATION_PLUS_${year}`,
        `JAPAN_RANKINGS_DASHBOARD_${year}`,
        `DATAPLUS_NEW_DATA_${year}`,
        `DATAPLUS_LATAM_${year}`,
        `COUNTRY_INSIGHTS_DASHBOARD_${year}`,
        `COLLEGE_RANKINGS_DASHBOARD_${year}`,
        `THE_STAFF_ACCESS_ALL_INSTITUTIONS`,
      ].includes(item),
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  legacyPermissions,
};
